<template>
  <v-container fluid class="pa-4">
    <v-row v-if="dicSettings.multilang == 1" no-gutters class="mb-4">
      <v-col>
        <language-select :langs="allLangs" @change-lang="emitFetch" />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <data-table
        ref="table-hoc"
        :height-offset="dicSettings.multilang == 1 ? 340 : 300"
        :filters.sync="filters"
        :schema="filterSchema"
        :headers="headers"
        :count="count"
        :loading="loading"
        :items="itemsList"
        :has-border="false"
        :data-table-props="{ sortBy: 'id' }"
        @fetch="loadItems"
      >
        <template v-slot:before-filter>
          <v-btn
            v-if="$can('UserDics/add')"
            color="primary"
            depressed
            class="mr-4"
            @click="editDialog = true"
          >
            <v-icon>mdi-plus</v-icon>
            Запись
          </v-btn>
        </template>

        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template #item.active="{ item: { active } }">
          <div class="d-flex justify-center">
            <!-- eslint-disable-next-line vue/valid-v-model -->
            <v-icon v-if="active" class="sv-enabled">mdi-check</v-icon>
            <v-icon v-else class="sv-disabled">mdi-close</v-icon>
          </div>
        </template>

        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template #item.actions="{ item }">
          <action-col>
            <action-col-btn
              v-if="$can('UserDics/edit') && dicSettings.keyvalue == 1"
              tooltip="Изменить"
              @click="editItem(item.id)"
            >
              mdi-pencil-outline
            </action-col-btn>
            <action-col-btn
              v-if="$can('UserDics/delete')"
              tooltip="Удалить"
              @click="deleteItem(item.id)"
            >
              mdi-close
            </action-col-btn>
          </action-col>
        </template>
      </data-table>

      <edit-dialog
        v-model="editDialog"
        :item-id="selectedItemId"
        :dic-id="dicId"
        :key-value="dicSettings.keyvalue"
        @close="selectedItemId = null"
        @apply="emitFetch"
      />
    </v-row>
  </v-container>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import LanguageSelect from "@/components/LanguageSelect";
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
import NotificationMixin from "@/mixins/NotificationMixin";
import DialogMixin from "@/mixins/DialogMixin";
import ResizeMixin from "@/mixins/ResizeMixin";
import QueryMixin from "@/mixins/QueryMixin";
import SearchFilter from "@/components/Filters/SearchFilter";
import Repository from "@/api/userdics.js";
import EditDialog from "./EditDialog.vue";

export default {
  components: { EditDialog, DataTable, LanguageSelect },
  mixins: [
    CheckPermissionMixin,
    NotificationMixin,
    DialogMixin,
    QueryMixin,
    ResizeMixin
  ],
  model: {
    prop: "dicId",
    event: "change"
  },
  props: {
    dicId: {
      type: [Number, String],
      default: ""
    }
  },
  data: () => ({
    selectedItemId: null,
    count: 0,
    options: {},
    loading: false,
    editDialog: false,
    filterDialog: false,
    filters: {},
    itemsList: [],
    dataTableProps: {
      disableSort: true
    }
  }),
  computed: {
    headers() {
      return [
        { text: "ID", value: "id" },
        ...(this.dicSettings.keyvalue == 1
          ? [{ text: "Ключ", value: "term" }]
          : []),
        { text: "Значение", value: "value" },
        {
          text: "Действия",
          value: "actions",
          sortable: false,
          align: "center",
          width: "155px"
        }
      ];
    },
    dicSettings() {
      return this.$store.getters.getDicNames.find(dic => dic.id == this.dicId);
    },
    filterSchema() {
      return {
        residentData: {
          filters: {
            ...(this.dicSettings.keyvalue == 1
              ? {
                  term: {
                    component: SearchFilter,
                    title: "Ключ",
                    filterBind: { showMethod: false }
                  }
                }
              : {}),
            value: {
              component: SearchFilter,
              title: "Значение",
              filterBind: { showMethod: false }
            }
          }
        }
      };
    },
    allLangs() {
      return this.$store.getters.getLangs;
    }
  },
  watch: {
    dicId() {
      this.emitFetch();
    }
  },
  methods: {
    async loadItems(params) {
      try {
        this.loading = true;
        const { data } = await Repository.getList(this.dicId, params);
        this.itemsList = data.list;
        this.count = data.count;
      } finally {
        this.loading = false;
      }
    },
    editItem(id) {
      this.selectedItemId = id;
      this.editDialog = true;
    },
    async deleteItem(id) {
      const confirm = await this.confirm(
        "Удаление записи",
        "Вы действительно хотите удалить эту запись? Это действие нельзя отменить!",
        {
          width: 550
        }
      );
      if (!confirm) return;
      try {
        const { data } = await Repository.delete(id);
        await this.$store.dispatch("fetchProfile");
        this.emitFetch();
        this.sendAlert(data.alert);
      } catch (error) {
        this.sendError(error);
      }
    },
    emitFetch() {
      this.$refs["table-hoc"].fetchData();
    }
  }
};
</script>
